<template>
<div>
<div class="auditng">
  <div class="fixed">
    <div class="head">
      <div class="text text1">账户总金额(元)</div>
      <div class="text money text2">{{moneyFmt(account.supperAccountTotal)}}</div>
      <div class="text text3"><span>总充值 {{moneyFmt(account.supperRechargeAmount)}}</span> <span>总收益 {{moneyFmt(account.supperIncomeAmount)}}</span></div>
      <div class="text text4"><span>昨日充值 {{moneyFmt(account.yesterdayRecharge)}}</span> <span>昨日提现 {{moneyFmt(account.yesterdayWithdraw)}}</span></div>
    </div>
    
    <div class="tabbar">
    <div class="bar_item"  :class= "{ 'select':index == selectFlag}"  v-for="(item, index) in tabData" :key="index"   @click="changeAuditingType(index)">{{item.name}}</div>
    </div>
  </div>
  <div class="fix"></div>
  <div class="detail" style="overflow: auto; height: 61%;">
        <!-- 下拉刷新组件 -->
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <!-- 列表组件 -->
        <van-list v-model="loading" :finished="finished" :finished-text="selectFlag == 0?rechargeBomTitle:withdrawBomTitle"   @load="onLoad" :offset="200"  :immediate-check="false" > 
  <div class="list" v-if="rechargelist.length > 0 && selectFlag == 0">
    <div class="list_item b-b" v-for="(item, index) in rechargelist" :key="index">
      <van-image v-if="item.rechargeType == 3" class="typeIcon" :src="require('@/assets/img/bank.png')" ></van-image>
      <van-image v-if="item.rechargeType == 2" class="typeIcon" :src="require('@/assets/img/zhifubao.png')" ></van-image>
      <van-image v-if="item.rechargeType == 1" class="typeIcon" :src="require('@/assets/img/weixing.png')" ></van-image>
      <div class="jiao" v-if="item.examineStatus == 0"><van-image :src="require('@/assets/img/wait_pass.png')" width="3rem"  height="1rem"></van-image></div>
      <div class="jiao" v-if="item.examineStatus == 1"><van-image :src="require('@/assets/img/yes_pass.png')" width="3rem" height="1rem"></van-image></div>
      <div class="jiao" v-if="item.examineStatus == 2"><van-image :src="require('@/assets/img/not_pass.png')" width="3rem" height="1rem"></van-image></div>
      <div class="item_l">
        <div class="text1 mb20" style="color: green;">+{{item.rechargeMoney}}</div>
        <div class="text2">{{item.createTime}}</div>
      </div>
      <div class="item_r">
        <div class="money" @click="itemCick(item)" >查看详情</div>
      </div>
    </div>
  </div>
  <div class="list" v-if="withDrawallist.length > 0  && selectFlag == 1 ">
       <div class="list_item b-b" v-for="(item, index) in withDrawallist" :key="index">
       <van-image v-if="item.withdrawalType == 3" class="typeIcon" :src="require('@/assets/img/bank.png')" ></van-image>
            <van-image v-if="item.withdrawalType == 2" class="typeIcon" :src="require('@/assets/img/zhifubao.png')" ></van-image>
            <van-image v-if="item.withdrawalType == 1" class="typeIcon" :src="require('@/assets/img/weixing.png')" ></van-image>
            <div class="jiao" v-if="item.examineStatus == 0"><van-image :src="require('@/assets/img/wait_pass.png')" width="3rem"  height="1rem"></van-image></div>
            <div class="jiao" v-if="item.examineStatus == 1"><van-image :src="require('@/assets/img/yes_pass.png')" width="3rem" height="1rem"></van-image></div>
            <div class="jiao" v-if="item.examineStatus == 2"><van-image :src="require('@/assets/img/not_pass.png')" width="3rem" height="1rem"></van-image></div>
      <div class="item_l">
        <div class="text1 mb20" style="color: chocolate;">-{{item.withdrawalMoney}}</div>
        <div class="text2">{{item.createTime}}</div>
      </div>
      <div class="item_r">
        <div class="money" @click="itemCick(item)">查看详情</div>
      </div>
    </div>
  </div>
  <div class="no_data"  v-if="(rechargelist.length == 0 && selectFlag  == 0) || (withDrawallist.length == 0 && selectFlag  == 1)">
        <div>
             <van-empty description="暂无数据" />
        </div> 
  </div>
</van-list>
</van-pull-refresh>
  </div>
</div>
 <van-popup v-model="show" bind:close="onClose"  catchtouchmove='true' position="bottom" round closeable>
  <div class="alert">
    <div class="title">充值审核</div>
    <div class="code">充值编码:{{rechargeItem.userId}}</div>
    <div class="alert_item">
      <div class="alert_item_l">用户昵称</div>
      <div class="alert_item_r">{{rechargeItem.createBy?rechargeItem.createBy: ''}}</div>
    </div>
    <div class="alert_item">
      <div class="alert_item_l">充值方式</div>
      <div class="alert_item_r" v-if="rechargeItem.rechargeType == 1">微信</div>
      <div class="alert_item_r" v-if="rechargeItem.rechargeType == 2">支付宝</div>
      <div class="alert_item_r" v-if="rechargeItem.rechargeType == 3">银行卡</div>
    </div>
    <div class="alert_item">
      <div class="alert_item_l">{{rechargeItem.rechargeType != 3? '账号':'卡号'}}</div>
      <div class="alert_item_r">{{rechargeItem.rechargeAccount}}</div>
    </div>
    <div class="alert_item">
      <div class="alert_item_l">充值金额</div>
      <div class="alert_item_r">{{rechargeItem.rechargeMoney}}元</div>
    </div>
    <div class="alert_item">充值截图</div>
    <div class="imageBox">
     <van-image catchtap="onPredivImage"  :src="rechargeItem.certificate" class="image" @click="imagePreview(rechargeItem.certificate)"></van-image>
    </div>
    <div class="alert_item">充值备注<div>{{ rechargeItem.businessMark }}</div></div>
    <div v-if="rechargeItem.examineStatus != 0" class="alert_item">审批备注<div>{{ rechargeItem.examineMark }}</div></div>
    <div v-else class="alert_item">审批备注<input v-model="rechargeExamineMark" type="text" placeholder="请填写说明" maxlength="15" placeholder-class="placeholder"/></div>
    <div class="btn" v-if="rechargeItem.examineStatus == 0">
      <!-- data-id="{{rechargeItem.id}} -->
        <div class="button" @click="release(1,0,rechargeItem.id)" >通过</div> 
        <div class="button" @click="release(2,0,rechargeItem.id)">拒绝</div>
    </div>
  </div>
</van-popup>
<van-popup v-model="show1" bind:close="onClose"  catchtouchmove='true' position="bottom" round closeable>
  <div class="alert">
    <div class="title">提现审核</div>
    <div class="alert_item">
      <div class="alert_item_l">用户昵称</div>
      <div class="alert_item_r">{{ withDrawalItem.niceName }}</div>
    </div>
    <div class="alert_item">
      <div class="alert_item_l">提现方式</div>
      <div class="alert_item_r" v-if="withDrawalItem.withdrawalType == 1">微信</div>
      <div class="alert_item_r" v-if="withDrawalItem.withdrawalType == 2">支付宝</div>
      <div class="alert_item_r" v-if="withDrawalItem.withdrawalType == 3">银行卡</div>
    </div>
    <div class="alert_item" v-if="withDrawalItem.withdrawalType == 3">
      <div class="alert_item_l">银行名称</div>
      <div class="alert_item_r">{{withDrawalItem.withdrawalBank}}</div>
    </div>
    <div class="alert_item">
      <div class="alert_item_l">{{withDrawalItem.withdrawalType != 3? '账户':'银行卡号'}}</div>
      <div class="alert_item_r">{{withDrawalItem.withdrawalAccount}}</div>
    </div>
    <div class="alert_item">
      <div class="alert_item_l">姓名</div>
      <div class="alert_item_r">{{withDrawalItem.userName}}</div>
    </div>
    <div class="alert_item">
      <div class="alert_item_l">提现金额</div>
      <div class="alert_item_r1"><div>{{withDrawalItem.withdrawalMoney}}元</div><div class="real_money">实际到账:{{withDrawalItem.realMoney}}元</div></div>
    </div>
    <div v-if="withDrawalItem.examineStatus != 0" class="alert_item">审批备注<div>{{ rechargeItem.examineMark }}</div></div>
    <div wx:else class="alert_item">审批备注<input type="text" placeholder="请填写备注" maxlength="10" v-model="withdrawExamineMark" placeholder-class="placeholder"/></div>
    <div class="btn" v-if="withDrawalItem.examineStatus == 0">
      <!-- data-id="{{withDrawalItem.id}}" -->
      <div class="button" @click="release(1,1,withDrawalItem.id)">通过</div>
      <div class="button" @click="release(2,1,withDrawalItem.id)">拒绝</div>
    </div>
  </div>
</van-popup>
</div>
</template>

<script>
import CountBox from "@/components/CountBox.vue";
import { moneyFmt } from "@/utils/moneyUtil";
import { ImagePreview } from 'vant';
import { getSupperRechargeList,getSupperWithdrawList,getSupperAccountInfo,rechargeExamine,withdrawExamine } from "@/api/auditing.js";
export default {
  name: "CartPage",
  components: {
    CountBox,
  },
  data() {
    return {
      isEdit: false,
      tabData: [{
      name: '充值记录',
    },{
      name: '提现记录',
    }],
    selectFlag: 0,
    
    show: false, // 充值弹框
    show1: false, // 提现弹框
    rechargeExamineMark: '',
    withdrawExamineMark: '',
    list: [],
    account :{
      supperAccountTotal: 0,
      supperRechargeAmount: 0,
      supperIncomeAmount :0,
      yesterdayRecharge: 0,
      yesterdayWithdraw: 0
    },
    rechargePageNum: 1,
    rechargeTotal: 0,
    rechargelist:[],
    withDrawalPageNum: 1,
    withDrawalTotal: 0,
    withDrawallist:[],
    rechargeItem:{},
    withDrawalItem:{},
    isLoading: false, // 控制下拉刷新的加载状态
    loading: false, // 控制上拉加载的加载状态
    finished: false, // 是否已加载完全部数据
    rechargeBomTitle: '', // 上拉加载完成时的文本
    withdrawBomTitle:'',
    };
  },
  computed: {

    isLogin() {
      return this.$store.getters.token;
    },
  },
  created() {
    //必须是登录过的用户 才能获取购物车列表
    this.informPort(true);
    this.supperAccountInfo();
  },
  methods: {

    moneyFmt(num){
       return moneyFmt(num)
    },
    changeAuditingType(index){
     this.selectFlag = index
     if(this.selectFlag == 0  && this.rechargelist.length == 0){
      this.onRefresh()
     }
     if(this.selectFlag == 1  && this.withDrawallist.length == 0){
      this.onRefresh()
     }
     
    },
    imagePreview(url){
      ImagePreview({
        images: [url],
        closeable: true,
        });
    },

    itemCick(item) {
      console.log(item)
      if (this.selectFlag == 0) { // 充值
         this.show= true;
         this.rechargeItem= item
      } else {
          this.show1=true,
          this.withDrawalItem= item
    
      } 
  },
  supperAccountInfo(){
    getSupperAccountInfo().then(res =>{
      if(res.code == 200 ){
        this.account = res.data;
      }else {
        this.$toast.fail({message: res.msg,duration: 3000})
      }
    })
  },
    // 获取列表数据
   informPort(flag) {
      if(this.selectFlag == 0){
        getSupperRechargeList(this.rechargePageNum).then(res => {
        console.log(res)
        if (res.code == 200 && res.rows) {
          console.log(res)
          let dataList = res.rows
          if (dataList && dataList.length) {
            if (flag) {
              this.rechargelist = dataList
            } else {
              this.rechargelist = [...this.rechargelist, ...dataList]
            }
          }
          this.rechargeTotal = res.total
          this.loading = false
          this.finished = false
          if (this.rechargelist.length >= this.rechargeTotal) {
            this.rechargeBomTitle = '到底了~ ' + '共计' + res.total + '条'
            this.finished = true
          } else {
            this.rechargePageNum += 1
            this.rechargeBomTitle = ''
          }
        }
      })
    }
    if(this.selectFlag == 1){
      getSupperWithdrawList(this.withDrawalPageNum).then(res => {
        console.log(res)
        if (res.code == 200 && res.rows) {
          console.log(res)
          let dataList = res.rows
          if (dataList && dataList.length) {
            if (flag) {
              this.withDrawallist = dataList
            } else {
              this.withDrawallist = [...this.withDrawallist, ...dataList]
            }
          }
          this.withDrawalTotal = res.total
          this.loading = false
          this.finished = false
          if (this.withDrawallist.length >= this.withDrawalTotal) {
            this.withdrawBomTitle = '到底了~ ' + '共计' + res.total + '条'
            this.finished = true
          } else {
            this.withDrawalPageNum += 1
            this.withdrawBomTitle = ''
          }
        }
      })
    }
    },
    // 下拉刷新
    onRefresh() {
      this.finished = true
      this.loading = true
      this.isLoading =true
      if(this.selectFlag == 0 ){
        this.rechargePageNum = 1
        this.rechargelist = []
      }
      if(this.selectFlag == 1){
        this.withDrawallist = []
        this.withDrawalPageNum = 1
      }
      setTimeout(() => {
        this.isLoading = false // 结束下拉刷新的加载状态
        this.informPort(true) // 重新获取列表数据
        this.$toast.success('刷新成功')
      }, 300)
    },
    // 上拉加载
    onLoad() {
      this.informPort() 
      // 获取更多列表数据
      
    },
    release(flag,type,id) {
    if (type == 0) { // 充值
      let params = {
        examineMark: this.rechargeExamineMark,
        examineStatus: flag,
        id: id
       }
       rechargeExamine(id, params).then(res => {
        if (res.code != 200) {
          this.$toast.fail({message: res.msg,duration: 3000})
        }else{
          this.$toast.success({message: "审核完成",duration: 3000})
          setTimeout(() => {
              this.show = false,
              this.rechargeExamineMark= ''  
              this.onRefresh()
          }, 2000)
        }
        })
      } else {
        let params = {
          examineMark: this.withdrawExamineMark,
          examineStatus: flag,
          id: id
        }
       withdrawExamine(id, params).then(res => {
          if (res.code != 200) {
            this.$toast.fail({message: res.msg,duration: 3000})
          }else{
            this.$toast.success({message: "审核完成",duration: 3000})
            setTimeout(() => {
              this.show1 = false,
              this.withdrawExamineMark= ''  
              this.onRefresh()
              this.onRefresh()
            }, 2000)
          }
        })
    }
  },

  },

};
</script>

<style lang="less" scoped>
// 主题 padding
.auditng {
    width: 100%;
    height: 100vh;
    background: url(@/assets/img/my_bg.png) no-repeat left center;
    background-size: 100% 100%;
    overflow: hidden;
    padding-top:4px;
}
.auditng .fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  height: 15rem;
}
.auditng .fixed .head {
  width: 85%;
  background: url(@/assets/img/my_info_bg.png) no-repeat left center;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 3%;
  border-radius: 8px;
  padding: 9%;
  height: 78%;
}

.auditng .fixed .head .text {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #d8d7d7;
  letter-spacing: 0;
  font-weight: 400;
  padding: 0 5px;
}
.auditng .fixed .head .money {
  font-family: PingFangSC-Medium;
  font-size: 30px;
  font-weight: 500;
}
.auditng .fixed .head .text1 {
  margin-top: 1%;
}
.auditng .fixed .head .text2 {
  margin-top: 2%;
  color: #fff;
}
.auditng .fixed .head .text3 {
  margin-top: 4%;
  display: flex;
  justify-content: space-between;
}
.auditng .fixed .head .text4 {
   margin-top: 2%;
   margin-bottom: 2%;
  display: flex;
  justify-content: space-between;
}
.auditng .fix {
  height: 15rem;
}
.auditng .detail {
  background: url(@/assets/img/auditing_detail_bg.png) no-repeat left center;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 3%;
  border-radius: 8px;
  padding: 20px;
  padding-bottom: 2rem;
}


.tabbar {
    margin-top: 2%;
    display: flex;
    justify-content: space-around;
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    .bar_item {
        background-color: rgb(156, 156, 156);
        border-radius: 8px;
        padding: 2px 8px;
    }
    .select {
      text-align: center;
      font-weight: 700;
      position: relative;
      background-color: rgb(106, 171, 187);
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 0;
        height: 6rpx;
        width: 60rpx;
        background: #111;
        transform: translateX(-50%);
        border-radius: 30rpx 30rpx 0rpx 0rpx;
      }
    }
  }
.no_data {
  margin-top: 20%;
  font-weight: 700;
}


.list {
  padding-bottom: 16px;
}
.list .list_item {
  display: flex;
  align-items: center;
  padding: 10px 22px;
  position: relative;
  margin-top: 1px;
  border-bottom: 1px solid #516388;
}
.list .list_item .jiao {
  position: absolute;
  right: 22px;
  top: 0;
}
.list .list_item .jiao img {
  width: 64px;
  height: 18px;
}
.list .list_item .jiao .wait {
  width: 52px;
}
.list .list_item .jiao .not {
  width: 76px;
}
.list .list_item .typeIcon {
  width: 35px;
  height: 35px;
  margin-right: 8px;
}
.list .list_item .item_l,
.list .list_item .item_r {
  flex: 1;
}
.list .list_item .item_l .text1,
.list .list_item .item_r .text1 {
  font-size: 16px;
  color: #f8f8f8;
  line-height: 16px;
}
.list .list_item .item_l .text2,
.list .list_item .item_r .text2 {
  font-size: 14px;
  color: #f8f8f8;
  line-height: 14px;
  font-weight: 400;
}
.list .list_item .item_l .mb20,
.list .list_item .item_r .mb20 {
  margin-bottom: 8px;
}
.list .list_item .item_r {
  text-align: right;
}
.list .list_item .item_r .money {
  text-align: right;
  position: absolute;
  right: 22px;
  top: 50%;
  font-size: 14px;
  color: rgb(177,213,189);
  font-weight: 400;
  transform: translateY(-50%);
}
.alert {
  margin: 12px 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #fff;
  line-height: 16px;
}
.alert .title {
  font-size: 20px;
  color: #fff;
  text-align: center;
  line-height: 20px;
  font-weight: 700;
}
.alert .code {
  font-size: 15px;
  color: #FF4800;
  text-align: center;
  font-weight: 400;
  margin-top: 1%;
}  
.alert .info {
    padding: 10px 16px;
    width: 95%;
    background: #FFFBE8;
    font-size: 14px;
    color: #FB7311;
    line-height: 20px;
    font-weight: 400;
    margin: 0 auto;
    margin-top: 3%;
    border-radius: 17px
}
::v-deep .van-field__label {
  color: #fff;
}
::v-deep .van-popup{
  background-color: #151925;
}
::v-deep .van-field__control {
  color: #fff;
}
.alert .chonglist {
  margin-top: 12px;
  display: flex;
}
.alert .chonglist .item {
  padding: 5px 11px;
  border: 1px solid #cccccc;
  border-radius: 8px;
  margin-left: 5%;
}
.alert .alert_item {
  display: flex;
  padding: 0 16px;
  align-items: center;
  justify-content: space-between;
  margin-top: 2%;
  height: 48px;
  background-color: #151925;
  font-size: 18px;
}
.alert .alert_item .df {
  display: flex;
}
.alert .alert_item .alert_item_type {
  padding: 5px 11px;
  border: 1px solid #cccccc;
  border-radius: 8px;
  margin-left: 12px;
  background-color: #9c9c9c;
}
.alert .alert_item input {
  flex: 1;
  margin-left: 8px;
  font-size: 16px;
  text-align: right;
  background-color: transparent;
  border: none;
  color: #d1c8c8;
}
.alert .alert_item .placeholder {
  font-size: 16px;
  font-weight: 400;
  color: #BBBBBB;
}
.alert .select {
  background-color: #6aabbb !important;
  border: 1px solid #6aabbb !important;
}
.alert .imageBox {
  display: flex;
  flex-wrap: wrap;
  padding: 0 16px;
}
.alert .imageBox .image {
  margin-right: 12px;
  margin-bottom: 12px;
  width: 84px;
  height: 84px;
  border-radius: 8px;
}
.alert .imageBox .add {
    margin-right: 12px;
    margin-bottom: 12px;
    width: 84px;
    height: 84px;
    border-radius: 18px;
    text-align: center;
    background: #D8D8D8;
    font-size: 14px;
    color: #666666;
    font-weight: 400;
}
.alert .imageBox .add .jia {
  margin-top: 19px;
  margin-bottom: 8px;
}
.alert .button {
    background: #FA4743;
    border-radius: 8px;
    color: #fff;
    height: 46px;
    line-height: 46px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    width: 50%;
    margin: 0 auto;
    margin-top: 12px;
}
.alert .btn {
  display: flex;
  justify-content: space-between;
}
.alert .btn .button {
  width: 45%;
}
.alert_item_r1 {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.real_money {
  margin-top: 3px;
  font-size: 12px;
  color: #fff;
}
.alert .btn .button:first-child {
  border: 2rpx solid #FA4743;
  background: #fff;
  color: #FA4743;
}
</style>